import React from "react";
import SupportPatientHeader from "../SupportPatientHeader";
import Footer from "../Footer";

const SupportPatientProgram = () => {
  return (
    <>
      <SupportPatientHeader />
      <main className="inner-page">
        <section className="container">
          <div className="row">
            <div className="col-sm-12">
              <h1 className="text-uppercase">Program</h1>
              <div className="spacer-1"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div
                className="card bg-blue rounded-0 border-0 text-center p-4 h-100 d-flex justify-content-center"
                style={{ minHeight: "500px" }}
              >
                <p className="mb-0 fs-24 fw-bold text-white lh-sm">
                  Information about the Program <br /> for Patients
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default SupportPatientProgram;
